export const SUBSCRIPTION_PLANS = [
  {
    name: 'basic',
    priceId: 'price_1QoO5PJz8eaLCKPm0OPt1Jqz',
    link: 'https://buy.stripe.com/14k6or6aN1va9iM145',
    price: '€20/year',
    description: '1 upload, 3 year exchange rate data',
    perfectFor: 'Perfect for beginners with simple investment situations',
    features: [
      'Includes 1 upload',
      '3 year historical exchange rate data',
      'Email support',
    ],
  },
  {
    name: 'pro',
    priceId: 'price_1QoO35Jz8eaLCKPmwWzDoqcA',
    link: 'https://buy.stripe.com/eVaaEH1Uxb5KcuY6oo',
    price: '€50/year',
    description: 'unlimited uploads, 25 year exchange rate data',
    perfectFor:
      'Perfect for passive investors looking to save hours of manual calculations',
    features: [
      'Unlimited uploads',
      '25 year historical exchange rate date',
      'Priority support',
    ],
  },
]
